// Contact form contract shared by the /api/contact route and the ContactForm UI.
// It is published to the LumaCore Client Form Hub as version 2 (version 1 is the dashboard starter template).
// Changing any value here requires publishing a new version.

// Label of the optional, unchecked-by-default SMS checkbox. Paste this exact text into the
// hub's Customer replies settings so the saved consent wording matches the website.
export const SMS_CONSENT_TEXT =
  "Text me about my message. By checking this box, I agree to receive texts from Olive Grove about my inquiry at the phone number above. Msg & data rates may apply. Reply STOP to opt out.";

export const CONTACT_SUBJECTS = [
  "General Inquiry",
  "Product Questions",
  "Tasting Bar Information",
  "Order Support",
  "Feedback",
  "Other",
] as const;

export const contactContract = {
  version: 2,
  sensitivity: "standard",
  successMessage:
    "Thank you for reaching out to Olive Grove! We received your message and typically respond within 24 hours.",
  fields: [
    { key: "firstName", label: "First name", type: "text", semantic: "contact.first_name", required: true, maxLength: 60 },
    { key: "lastName", label: "Last name", type: "text", semantic: "contact.last_name", required: true, maxLength: 60 },
    { key: "email", label: "Email", type: "email", semantic: "contact.email", required: true, maxLength: 320 },
    { key: "phone", label: "Phone", type: "phone", semantic: "contact.phone", maxLength: 30 },
    { key: "subject", label: "Subject", type: "select", semantic: "inquiry.subject", options: CONTACT_SUBJECTS },
    { key: "message", label: "Message", type: "textarea", semantic: "inquiry.message", required: true, maxLength: 3000 },
    { key: "smsConsent", label: "SMS consent", type: "checkbox", semantic: "consent.sms" },
  ],
} as const;

export type ContactField = (typeof contactContract.fields)[number];
export type ContactFieldKey = ContactField["key"];

export function contactField<K extends ContactFieldKey>(key: K) {
  const field = contactContract.fields.find((f) => f.key === key);
  if (!field) throw new Error(`Unknown contact field: ${key}`);
  return field as Extract<ContactField, { key: K }>;
}
